export var setDifference = function setDifference(source, target) {
  var result = new Set();
  source.forEach(function (value) {
    if (!target.has(value)) result.add(value);
  });
  return result;
};